export interface PlanHealth {
    isLoading: boolean;
    isPlaybookEnabled: boolean;
    hasRegion: boolean;
    hasNoTouchpoints: boolean;
    hasAnyGoal: boolean;
    hasTouchpointGoal: boolean;
    isFallingShortOfGoal: boolean;
}

export type PlanHealthBannerKind =
    | "hidden"
    | "setupPlaybook"
    | "noGoalsWithoutPlaybook"
    | "noGoals"
    | "fallingShort"
    | "onTrack";

export const metricFallsShortOfGoal = (target: number, projected: number): boolean =>
    target > 0 && projected < target;

const isPlanHealthUnavailable = (planHealth: PlanHealth): boolean =>
    !planHealth.isPlaybookEnabled || !planHealth.hasRegion || planHealth.isLoading;

const touchpointGoalBannerKind = (planHealth: PlanHealth): PlanHealthBannerKind => {
    if (!planHealth.hasTouchpointGoal) {
        return "hidden";
    }
    return planHealth.isFallingShortOfGoal ? "fallingShort" : "onTrack";
};

const noGoalsBannerKind = (planHealth: PlanHealth): PlanHealthBannerKind =>
    planHealth.hasNoTouchpoints ? "noGoalsWithoutPlaybook" : "noGoals";

export const bannerKindPrioritizingPlaybook = (
    planHealth: PlanHealth,
): PlanHealthBannerKind => {
    if (isPlanHealthUnavailable(planHealth)) {
        return "hidden";
    }
    if (planHealth.hasNoTouchpoints) {
        return "setupPlaybook";
    }
    if (!planHealth.hasAnyGoal) {
        return noGoalsBannerKind(planHealth);
    }
    return touchpointGoalBannerKind(planHealth);
};

export const bannerKindPrioritizingGoals = (
    planHealth: PlanHealth,
): PlanHealthBannerKind => {
    if (isPlanHealthUnavailable(planHealth)) {
        return "hidden";
    }
    if (!planHealth.hasAnyGoal) {
        return noGoalsBannerKind(planHealth);
    }
    if (planHealth.hasNoTouchpoints) {
        return "setupPlaybook";
    }
    return touchpointGoalBannerKind(planHealth);
};
